export default {
  subscribeTodayForJust: {
    en: 'Subscribe today for just $14.95',
  },
}
